import React from "react";

export const NoLayout: React.FunctionComponent<{ children?: React.ReactNode }> = ({ children }) => (
  <>{children}</>
);
